export function getAccessorExpression(fn) {
    /* tslint:disable:max-line-length */
    const classic = /^function\s*\([$_\w\d]+\)\s*\{(?:\s*"use strict";)?\s*(?:[$_\w\d.['"\]+;]+)?\s*return\s+[$_\w\d]+\.([$_\w\d]+)\s*;?\s*\}$/;
    /* tslint:enable:max-line-length */
    const arrow = /^\(?[$_\w\d]+\)?\s*=>\s*[$_\w\d]+\.([$_\w\d]+)$/;
    const match = classic.exec(fn) || arrow.exec(fn);
    if (match === null) {
        throw new Error(`Unable to parse accessor function:\n${fn}`);
    }
    return match[1];
}
export function isEmail(value) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value);
}
export function isPresent(value, treatZeroAsNull) {
    if (value === undefined || value === null)
        return false;
    if (treatZeroAsNull && typeof (value) === "number" && value === 0)
        return false;
    if (typeof (value) === "string") {
        return !!value;
    }
    else if (typeof (value) === "boolean")
        return value;
    else
        return true;
}
export function isLowerCasePresent(value) {
    // if (!value || value.length < 6) return true;
    return (/[a-z]/.test(value));
}
export function isUpperCasePresent(value) {
    // if (!value || value.length < 6) return true;
    // if (oneLowerCase(value) == false) return true;
    return (/[A-Z]/.test(value));
}
export function isStartsWith(value, startString) {
    // if (!value || value.length < 6) return true;
    // if (oneUpperCase(value) == false) return true;
    if (value && startString)
        return value.startsWith(startString);
    return true;
}
export function isEndssWith(value, endString) {
    // if (!value || value.length < 6) return true;
    // if (oneUpperCase(value) == false) return true;
    if (value && endString)
        return value.endsWith(endString);
    return true;
}
export function isNumberPresent(value) {
    // if (!value || value.length < 6) return true;
    // if (oneUpperCase(value) == false) return true;
    return (/[0-9]/.test(value));
}
export function isValidCreditCard(value) {
    if (!value)
        return false;
    value = value.replace(/ /g, "");
    if (!value) {
        return false;
    }
    if (value.length < 15 || value.length > 16)
        return false;
    const cc = value.split("").reverse().join("");
    const length = cc.length;
    let sum = 0;
    let t;
    for (let i = 1; i < length; i += 2) {
        t = cc[i] * 2;
        sum += t % 10;
        sum += (t - t % 10) / 10;
    }
    for (let i = 0; i < length; i += 2) {
        sum += parseInt(cc[i], 0);
    }
    return sum % 10 === 0;
}
export function isHHMMValid(value) {
    if (!value || value.trim() === ":")
        return true;
    const parts = value.split(":");
    if (parts.length !== 2)
        return false;
    const [hh, mm] = parts.map(x => parseInt(x));
    if (isNaN(hh))
        return false;
    if (hh < 0 || hh > 24)
        return false;
    if (isNaN(mm))
        return false;
    if (mm < 0 || mm > 60)
        return false;
    return true;
}
export function isMMYYValid(value) {
    if (!value || value.trim() === "/")
        return true;
    const parts = value.split("/");
    if (parts.length !== 2)
        return false;
    const month = parseInt(parts[0].trim(), 0);
    if (isNaN(month))
        return false;
    if (month <= 0 || month > 12)
        return false;
    let year = parseInt(parts[1].trim(), 0);
    year = 2000 + year;
    if (isNaN(year))
        return false;
    const d = new Date();
    const currentMonth = d.getMonth() + 1;
    const currentyear = d.getFullYear();
    if (year < currentyear)
        return false;
    if (year > currentyear)
        return true;
    if (month < currentMonth)
        return false;
    return true;
}
export function isMMYYPresent(value) {
    if (!value)
        return false;
    const parts = value.split("/");
    if (parts.length === 2 && !parts[0] && !parts[1])
        return false;
    if (parts.length === 1 && !parts[0])
        return false;
    if (parts.length === 0)
        return false;
    return true;
}
